import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette, typography }) =>
  createStyles({
    treatmentCost: {
      '& label': {
        display: 'flex',
        gap: '1rem',

        '& > div': {
          width: '13rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          paddingInline: '0.8rem',
          borderRadius: 4,
          outline: `1px solid ${palette.secondary.light}`,

          color: '#727970',
          fontFamily: typography.body1.fontFamily,
          fontWeight: 600,
          backgroundColor: palette.background.paper,
          fontSize: '1.4rem',
          boxSizing: 'border-box',

          '& input': {
            border: 'none',
            outline: 'none',
            color: 'inherit',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            fontSize: 'inherit',
            textAlign: 'right',
            width: '100%',
          },

          '&:focus-within': {
            outlineWidth: 2,
          },
        },
      },

      '& > p': {
        marginLeft: '1.6rem',
      },
    },
  }),
)
